/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import type { MetricType } from 'web-vitals';

const reportWebVitals = (onPerformanceEntry?: (metric: MetricType) => void) => {
  if (onPerformanceEntry && typeof onPerformanceEntry === 'function') {
    import('web-vitals').then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
      onCLS(onPerformanceEntry);
      onINP(onPerformanceEntry);
      onFCP(onPerformanceEntry);
      onLCP(onPerformanceEntry);
      onTTFB(onPerformanceEntry);
    });
  }
};

export default reportWebVitals;
